var _excluded = ["children", "value", "config"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import classnames from 'classnames';
import { Input, Form } from 'antd';
import { MacroManager } from '../macro-manager/macro-manager';
import EmojiManager from '../emoji-manager/emoji-manager';
import { useDebouncedValue } from '../../hooks';

var FragmentWrapper = function FragmentWrapper(_) {
  return _.children;
};

var CharacterLimitWrapper = function CharacterLimitWrapper(_) {
  var _config$messageOverri;

  var children = _.children,
      value = _.value,
      config = _.config,
      props = _objectWithoutProperties(_, _excluded);

  var currVal = (value || '').toString().trim();
  var currLen = currVal.length;
  var aboveMax = !config.max ? false : config.max < currLen;
  var belowMin = !config.min ? false : config.min > currLen;
  var constraintMet = !!config.max && (!config.maxConstraint ? false : config.max <= currLen);
  var msg = "".concat(currLen, " ").concat(currLen === 1 ? 'Character' : 'Characters');

  if (belowMin && !!config.belowMinMessage) {
    msg += ". ".concat(config.belowMinMessage);
  } else if (aboveMax && !!config.aboveMaxMessage) {
    msg += ". ".concat(config.aboveMaxMessage);
  }

  return /*#__PURE__*/React.createElement("span", {
    className: classnames('char-limit-wrapper', {
      'outside-limits': belowMin || aboveMax,
      'constraint-met': constraintMet
    })
  }, children, /*#__PURE__*/React.createElement("span", {
    className: classnames('char-limit-message')
  }, (_config$messageOverri = config.messageOverride) !== null && _config$messageOverri !== void 0 ? _config$messageOverri : msg));
};

var TemplatizedTextField = forwardRef(function (props, ref) {
  var _ref, _props$limits, _ref2, _props$defaultValue;

  var disabled = props.disabled,
      onChange = props.onChange,
      label = props.label,
      size = props.size,
      hideEmojis = props.hideEmojis,
      hideMacros = props.hideMacros,
      customMacroOptions = props.customMacroOptions,
      validMacroOptionTypes = props.validMacroOptionTypes,
      placeholder = props.placeholder,
      className = props.className,
      inputClassName = props.inputClassName;

  var _useDebouncedValue = useDebouncedValue(function (v) {
    onChange === null || onChange === void 0 ? void 0 : onChange(v);
  }, undefined, 320),
      _useDebouncedValue2 = _slicedToArray(_useDebouncedValue, 2),
      value = _useDebouncedValue2[0],
      setValue = _useDebouncedValue2[1];

  var EmojiWrapper = !hideEmojis ? EmojiManager : FragmentWrapper;
  var MacroWrapper = !hideMacros ? MacroManager : FragmentWrapper;
  var LimitWrapper = !!props.limits ? CharacterLimitWrapper : FragmentWrapper;
  var currVal = ((_ref = value !== null && value !== void 0 ? value : props.value) !== null && _ref !== void 0 ? _ref : '').toString().trim();
  var macroDetected = /{{/.test(currVal);
  var limits = (_props$limits = props.limits) !== null && _props$limits !== void 0 ? _props$limits : {};

  if (!hideMacros && !!customMacroOptions && macroDetected) {
    limits.messageOverride = 'Unable to calculate characters due to dynamic macro length';
  }
  /**
   * Handle external value overrides
   */


  React.useEffect(function () {
    var _props$value;

    if (!!props.value && ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.trim()) !== (value === null || value === void 0 ? void 0 : value.trim())) {
      setValue(props.value);
    }
  }, [props.value]);
  /**
   * Forward ref assigned internal to allow external control
   */

  var inputRef = useRef(null);

  var focusInput = function focusInput() {
    setTimeout(function () {
      if (!inputRef.current) {
        return;
      }

      ;
      inputRef.current.focus();
    }, 20);
  };

  useImperativeHandle(ref, function () {
    return {
      focusInput: function (_focusInput) {
        function focusInput() {
          return _focusInput.apply(this, arguments);
        }

        focusInput.toString = function () {
          return _focusInput.toString();
        };

        return focusInput;
      }(function () {
        return focusInput();
      })
    };
  }, []);
  return /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: props.noStyle,
    className: className,
    label: label
  }, /*#__PURE__*/React.createElement(LimitWrapper, {
    value: currVal,
    config: limits
  }, /*#__PURE__*/React.createElement(EmojiWrapper, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(MacroWrapper, {
    types: (_ref2 = props.macroTypes) !== null && _ref2 !== void 0 ? _ref2 : ['location', 'custom'],
    customOptions: customMacroOptions,
    disabled: disabled,
    validOptionTypes: validMacroOptionTypes
  }, /*#__PURE__*/React.createElement(Input, {
    ref: function ref(el) {
      return inputRef.current = el;
    },
    maxLength: limits.maxConstraint ? limits === null || limits === void 0 ? void 0 : limits.max : undefined,
    className: inputClassName,
    disabled: disabled,
    size: size,
    placeholder: placeholder,
    defaultValue: (_props$defaultValue = props.defaultValue) !== null && _props$defaultValue !== void 0 ? _props$defaultValue : undefined,
    value: value !== null && value !== void 0 ? value : props.value,
    onChange: function onChange(ev) {
      return setValue(ev.target.value);
    },
    autoComplete: props.autoComplete
  })))));
});
export default TemplatizedTextField;